import Casino from '@dialinvest/react-casino';
import store from './store';
import { clearUserData } from '../../redux/actions/userActions';
import { toggleModalInTimeOut } from '../../redux/actions/signInModalActions';
import { soliticsPing } from '../Solitics';

export default class TimeOut {
  constructor(cookies) {
    this.cookies = cookies;
    this.casino = new Casino.models.Logout('FRONTEND');
  }

  timeOut() {
    this.casino.perform();
    this.openModal();

    return true;
  }

  openModal() {
    store.dispatch(toggleModalInTimeOut());
    store.dispatch(clearUserData());
    window.location.href = '/';
  }

  extendCookie = () => {
    const date = new Date();
    const time = Number(process.env.REACT_APP_TIMEOUT_MINUTES) * 60000;

    const { userLoggedIn, ...session } = store.getState().userState;

    date.setTime(date.getTime() + time);

    soliticsPing();
    if (session?.sessionKey) this.cookies.set('Session', JSON.stringify(session), { path: '/', expires: date });
  };
}
